import React from 'react';
import Header from '../../components/Header/Header';
import "./regiser.scss"
import "./register.css"
import logo from "../../../images/logo.png"

import { Radio, RadioGroup, FormControlLabel, FormControl, FormLabel } from '@mui/material';
import Footer from '../../components/Footer/Footer';


const Register = () => {
    const [value, setValue] = React.useState('female');

    const handleChange = (event) => {
        setValue(event.target.value);
    };
    return (
        <>
            <Header />
            <div className="form-body" >
                <div className="overlay_bg"></div>
                <div className="form-content">
                    <div className="container">
                        <div className="row">
                            <div className="form-box">
                                <div className="formify_header text-center">
                                    <a href="#" className="mb-3 formify_logo">
                                        <img src={logo}
                                            alt="Image not found " /></a>
                                    <h4 className="form_title"> Register  Form </h4>
                                </div>


                                <form action="#" className="signup_form border-radius-0">
                                    <div className="form-group">
                                        <label className="input_title" for="inputName">Name <span className="text-danger">*</span></label>
                                        <input type="email" className="form-control" id="inputName"
                                            placeholder="Enter Your Name" required="" />
                                    </div>
                                    <div className="form-group">
                                        <label className="input_title" for="inputEmail">Email <span className="text-danger">*</span></label>
                                        <input type="email" className="form-control" id="inputEmail" placeholder="Email address"
                                            required="" />
                                    </div>
                                    <div className="form-group">
                                        <FormControl component="fieldset">
                                            <FormLabel component="legend" style={{ color: "#fff" }}>Your Current Status  <span className="text-danger">*</span>
                                            </FormLabel>
                                            <RadioGroup
                                                aria-label="gender"
                                                name="controlled-radio-buttons-group"
                                                value={value}
                                                onChange={handleChange}
                                            >
                                                <FormControlLabel value="student" control={<Radio />} label="Student" />
                                                <FormControlLabel value="job_holder" control={<Radio />} label="Job Holder" />
                                                <FormControlLabel value="none" control={<Radio />} label=" None" />
                                            </RadioGroup>
                                        </FormControl>
                                    </div>

                                    <div className="form-group">

                                        <FormControl component="fieldset">
                                            <FormLabel component="legend">Your Current Status  <span className="text-danger">*</span>
                                            </FormLabel>
                                            <RadioGroup
                                                aria-label="gender"
                                                name="controlled-radio-buttons-group"
                                                value={value}
                                                onChange={handleChange}
                                            >
                                                <FormControlLabel value="jsc" control={<Radio />} label="JSC" />
                                                <FormControlLabel value="ssc" control={<Radio />} label="SSC" />
                                                <FormControlLabel value="hsc" control={<Radio />} label="HSC" />
                                                <FormControlLabel value="diploma" control={<Radio />} label="Diploma" />
                                                <FormControlLabel value="graduation" control={<Radio />} label="Graduation" />
                                                <FormControlLabel value="masters" control={<Radio />} label="Masters" />
                                                <FormControlLabel value="others" control={<Radio />} label="others" />
                                            </RadioGroup>
                                        </FormControl>
                                    </div>
                                    <div className="form-group">
                                        <button type="submit" className="btn action_btn thm_btn text-capitalize">Submit </button>
                                    </div>


                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />

        </>
    );
};

export default Register;